"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const material_1 = require("@mui/material");
const lodash_1 = require("lodash");
const uiConstants_1 = require("../../../../constants/uiConstants");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../drawerAside"));
const SelectAside = ({ isOpen, model, setModel, onClose, onSelect, options, title, selectAllLabel, hasSelectAll, allowEmptySelection, emptyMessage, onSubmit, submitButtonText = 'Save', optionProperty = 'description', isMultiSelect = false, }) => {
    const isAllSelected = () => {
        if (!(isMultiSelect === true) || (0, lodash_1.isEmpty)(options) || (0, lodash_1.isEmpty)(model)) {
            return false;
        }
        const optionIds = options.map(option => option.id);
        return (0, lodash_1.isEmpty)((0, lodash_1.difference)(optionIds, model.id));
    };
    const toggleSelectAll = () => {
        if (isAllSelected()) {
            if (setModel) {
                setModel({ ...model, id: [] });
            }
        }
        else {
            if (setModel) {
                setModel({ ...model, id: options.map(option => option.id) });
            }
        }
    };
    const isChecked = option => {
        if (!isMultiSelect || !hasSelectAll) {
            return isSelected(option);
        }
        return isSelected(option) && !isAllSelected();
    };
    const isSelected = option => {
        if ((0, lodash_1.isNil)(model)) {
            return false;
        }
        else if (Array.isArray(model.id) && isMultiSelect === true) {
            return model.id.includes(option.id);
        }
        else {
            return model.id === option.id;
        }
    };
    const select = option => {
        if (!isMultiSelect) {
            if (onSelect) {
                onSelect({ option });
            }
            return;
        }
        if (!setModel) {
            return;
        }
        if (isAllSelected() && hasSelectAll) {
            setModel({ ...model, id: [option.id] });
        }
        else if (isSelected(option)) {
            setModel({ ...model, id: model.id.filter(element => element !== option.id) });
        }
        else {
            setModel({ ...model, id: [...model.id, option.id] });
        }
    };
    const hasNoneSelected = () => {
        return !(0, lodash_1.isEmpty)(model) && Array.isArray(model.id) && (0, lodash_1.isEmpty)(model.id);
    };
    const submit = () => {
        if (onSubmit) {
            onSubmit(model);
        }
    };
    const footerButtons = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "submit-buuton", label: submitButtonText, onClick: submit, disabled: !allowEmptySelection && hasNoneSelected(), color: uiConstants_1.UI_BUTTON_PRIMARY }) }));
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: 'selectAside', title: title || 'Select', open: isOpen, onClose: onClose, footerButtons: isMultiSelect ? footerButtons : null, children: (0, jsx_runtime_1.jsx)(material_1.FormGroup, { style: { margin: 1, justifyContent: 'space-between', flex: 1 }, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { mb: 'auto', p: 0 }, children: [options && (options.length === 0 || Object.keys(options).length === 0) ? (0, jsx_runtime_1.jsx)("p", { children: emptyMessage }) : '', (0, jsx_runtime_1.jsxs)(material_1.MenuList, { children: [isMultiSelect && hasSelectAll ? ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, { className: isAllSelected() ? 'ts-checked' : '', onClick: () => toggleSelectAll(), children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "select-item", children: selectAllLabel }), (0, jsx_runtime_1.jsx)(material_1.Typography, { style: { marginLeft: 'auto' }, children: isAllSelected() ? (0, jsx_runtime_1.jsx)(Check_1.default, {}) : '' })] })) : (''), options && options.length > 0
                                ? options.map(option => ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, { disabled: option?.disabled, onClick: () => select(option), className: isChecked(option) ? 'ts-checked' : '', children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "select-item", children: option.label }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "select-item", children: option[optionProperty] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { style: { marginLeft: 'auto' }, children: isChecked(option) ? (0, jsx_runtime_1.jsx)(Check_1.default, {}) : '' })] }, option.userId || option.id)))
                                : options && Object.keys(options).length > 0
                                    ? Object.keys(options).map(optionKey => ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, { className: isChecked(options[optionKey]) ? 'ts-checked' : '', disabled: options[optionKey].disabled, onClick: () => select(options[optionKey]), children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "select-item", children: options[optionKey].label }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "select-item", children: options[optionKey][optionProperty] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { style: { marginLeft: 'auto' }, children: isChecked(options[optionKey]) ? (0, jsx_runtime_1.jsx)(Check_1.default, {}) : '' })] }, options[optionKey].id)))
                                    : ''] })] }) }) }));
};
exports.default = SelectAside;
